module.exports = __webpack_public_path__ + "static/backlite-media-result-3-a2aa5fe921e00c31112e4f9b06d54804.png";